module.exports = __webpack_public_path__ + "static/media/features.d84f297b.png";